import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router';

import PageBase from '../../../app/PageBase';
import Table from '../../table/MsTable';
import { getIncompleteWorkflows } from '../../../redux/actions/workflowActions';


import { setWorkflowData } from '../../../redux/workflow';
import { getAuthUser } from '../../../redux/actions/authActions';

const mapStateToProps = state => ({
  open: state.workflowReducer.open,
  workflowId: state.workflowReducer.workflowId,
  workflowList: state.workflowReducer.workflowList,
  workflowIncompleteList: state.workflowReducer.workflowIncompleteList,
});

const mapDispatchToProps = {
  setWorkflowData,
  getIncompleteWorkflows,
};

const user = getAuthUser();

class WorkflowIncompleteList extends Component {


  static propTypes = {

  };

  constructor(props) {

    super(props);

    this.onChangeData = this.onChangeData.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);

  }


  componentDidMount() {

    this.getWorkflows();

  }

  getWorkflows() {

    const { getIncompleteWorkflows, setWorkflowData } = this.props;


    setTimeout(() => {

      getIncompleteWorkflows(user.context.idHolding).then(response => setWorkflowData({ workflowIncompleteList: response }));

    }, 100);

  }


  onChangeData(data) {


    this.props.setWorkflowData({
      workflowId: data[Object.keys(data)[0]] ? data[Object.keys(data)[0]].workFlowId : undefined,
      workflowData: data[Object.keys(data)[0]],
      open: Object.keys(data).length !== 0,
    });

  }

  close = () => this.props.history.push('/flow/list/');


  handleCreateClick = () => {

    this.props.setWorkflowData({ workflowId: null });
    this.props.history.push('/flow/form/');

  }

  handleEditClick = () => {

    this.props.history.push(`/flow/form/${this.props.workflowId}`);

  }


  render() {

    const { workflowIncompleteList, open } = this.props;


    return (
      <div>

        <PageBase
          title={I18n.t('titles.uncompleted_workflow')}
          navigation={`Configurações -> ${I18n.t('menu.users')}`}

          showCreateButton={!open}
          showEditButton={open}
          showDeleteButton={open}
          showBackButton
          handleCloseClick={this.close}
          handleCreateClick={this.handleCreateClick}
          handleEditClick={this.handleEditClick}
          handleDeleteClick={this.handleDeleteClick}
        >
          {
            workflowIncompleteList.length > 0 ? (
              <Table
                data={workflowIncompleteList}
                entryKey="workFlowId"
                paginate
                onPaginate={this.onPaginate}
                toolbar
                onSelectionChange={this.onChangeData}
                onSwitchChange={this.onSwitchChange}
                tableDef={[
                  { name: 'workFlowId', label: 'ID' },
                  { name: 'name', label: I18n.t('fields.name') },
                  { name: 'companyName', label: I18n.t('fields.company') },
                ]}
              />
            ) :
              <p> Não há fluxos incompletos para serem exibidos.</p>
          }


        </PageBase>


      </div>
    );

  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkflowIncompleteList));



// WEBPACK FOOTER //
// ./src/components/tracker/Flow/WorkflowIncompleteList.js